import { createEnvelopeSource } from './create-envelope-source';
import { NHL_COINS_EDITION_ID } from './nhl-coins-edition';

export const campaignNhlCoinsCollectionSource = createEnvelopeSource({
    label: 'NHL Coins booklet collection',
    endpoint: 'analytics/campaign-nhl-coins-collection-member',
    metrics: [
        { id: 'enrolledMembers', label: 'Enrolled players', type: 'scalar' },
        { id: 'collectors', label: 'Collectors', type: 'scalar' },
        {
            id: 'completeCollectors',
            label: 'Complete booklets',
            type: 'scalar',
        },
        {
            id: 'avgCoinsPerCollector',
            label: 'Avg. coins per collector',
            type: 'ratio',
        },
    ],
    forms: ['number', 'columns'],
    columnsAxisCells: {
        valueCell: 'enrolledMembers',
        forMetric: 'enrolledMembers',
    },
    regionGrain: 'province',
    staticParams: { campaignId: NHL_COINS_EDITION_ID },
});
